var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69099 6.49996L12.7529 1.43787C13.0824 1.1086 13.0824 0.576219 12.7529 0.246951C12.4237 -0.082317 11.8913 -0.082317 11.562 0.246951L6.49992 5.30904L1.43798 0.246951C1.10856 -0.082317 0.576335 -0.082317 0.247067 0.246951C-0.0823556 0.576219 -0.0823556 1.1086 0.247067 1.43787L5.30901 6.49996L0.247067 11.5621C-0.0823556 11.8913 -0.0823556 12.4237 0.247067 12.753C0.411161 12.9172 0.62692 12.9997 0.842526 12.9997C1.05813 12.9997 1.27374 12.9172 1.43798 12.753L6.49992 7.69088L11.562 12.753C11.7263 12.9172 11.9419 12.9997 12.1575 12.9997C12.3731 12.9997 12.5887 12.9172 12.7529 12.753C13.0824 12.4237 13.0824 11.8913 12.7529 11.5621L7.69099 6.49996Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCloseIcon);
export default __webpack_public_path__ + "static/media/menu-close-icon.85c79075be3fa609907f8f27d6395a21.svg";
export { ForwardRef as ReactComponent };